module.exports = __webpack_public_path__ + "img/logo_m.b9ce5a82.png";